import {Previous, Next} from './arrows';

const handleClick = (disabled: boolean, onClick: () => void) => {
  if (!disabled) {
    return onClick;
  }
};

const ArrowWrapper = ({
  children,
  leftDisabled,
  rightDisabled,
  onLeft,
  onRight,
}: {
  children: React.ReactNode;
  leftDisabled: boolean;
  rightDisabled: boolean;
  onLeft: () => void;
  onRight: () => void;
}) => (
  <div className={styles.container}>
    <span className="hidden md:block">
      <Previous disabled={leftDisabled} onClick={handleClick(leftDisabled, onLeft)} />
    </span>

    {children}

    <span className="hidden md:block">
      <Next disabled={rightDisabled} onClick={handleClick(rightDisabled, onRight)} />
    </span>
  </div>
);

export const SmallScreenArrowWrapper = ({
  children,
  leftDisabled,
  rightDisabled,
  onLeft,
  onRight,
}: {
  children: React.ReactNode;
  leftDisabled: boolean;
  rightDisabled: boolean;
  onLeft: () => void;
  onRight: () => void;
}) => (
  <div className="flex justify-between w-full">
    <span className="md:hidden">
      <Previous disabled={leftDisabled} onClick={handleClick(leftDisabled, onLeft)} />
    </span>
    <div className="flex gap-4 md:w-full md:justify-between">{children}</div>
    <span className="md:hidden">
      <Next disabled={rightDisabled} onClick={handleClick(rightDisabled, onRight)} />
    </span>
  </div>
);

const styles = {
  container: 'flex flex-row items-center justify-center',
};

export default ArrowWrapper;
